import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react'

interface TabNotificationContextValue {
  notificationRouteCounts: Map<string, number>
  notificationTabs: Set<string>
  setNotificationRouteCounts: (m: Map<string, number>) => void
  setNotificationTabs: (s: Set<string>) => void
}

const TabNotificationContext = createContext<TabNotificationContextValue>({
  notificationRouteCounts: new Map(),
  notificationTabs: new Set(),
  setNotificationRouteCounts: () => {},
  setNotificationTabs: () => {},
})

export function TabNotificationProvider({ children }: { children: ReactNode }) {
  const [notificationRouteCounts, setNotificationRouteCounts] = useState<Map<string, number>>(new Map())
  const [notificationTabs, setNotificationTabs] = useState<Set<string>>(new Set())

  const setRouteCounts = useCallback((m: Map<string, number>) => setNotificationRouteCounts(m), [])
  const setTabs = useCallback((s: Set<string>) => setNotificationTabs(s), [])

  return (
    <TabNotificationContext.Provider
      value={{
        notificationRouteCounts,
        notificationTabs,
        setNotificationRouteCounts: setRouteCounts,
        setNotificationTabs: setTabs,
      }}
    >
      {children}
    </TabNotificationContext.Provider>
  )
}

export function useTabNotifications() {
  return useContext(TabNotificationContext)
}

export default TabNotificationContext
